import { TERMS, TERMS_INTRO } from "../terms.ts";

/** The terms of use, set out to be read: on a page of their own, and above the button that agrees to them. */
export function TermsText() {
  return (
    <div className="terms">
      <p>{TERMS_INTRO}</p>
      {TERMS.map((s) => (
        <section key={s.heading} className="guide-part">
          <h2 className="section-label">{s.heading}</h2>
          <ul className="guide-list">
            {s.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}

/** The terms of use on a page of their own, for anyone to read, signed in or not. */
export function Terms() {
  return (
    <main className="signin terms-page">
      <p className="signin-place">The Table</p>
      <h1 className="lobby-title">Terms of use</h1>
      <TermsText />
    </main>
  );
}
